/**
 * The three-gesture sharing ceiling.
 *
 * Authorised by: product-concept §10 (light sharing: shared lists, The Toss, The Ask)
 * and implementation-brief §9, which lists the "three-gesture sharing ceiling" as a
 * consolidated non-negotiable. CLAUDE.md: **"Three sharing gestures, ever… No fourth."**
 *
 * The Toss and The Ask are phase 2 (§15), so this file deliberately models no behaviour.
 * What it does is give the ceiling a STRUCTURAL expression (critique 7.13): the union is
 * closed, and `SHARING_GESTURES` is a fixed-arity tuple with a compile-time proof of its
 * length, so a fourth gesture cannot be added without breaking the build and reading
 * this comment.
 */

export const SHARING_GESTURES = ['shared-list', 'toss', 'ask'] as const;
export type SharingGesture = (typeof SHARING_GESTURES)[number];

/**
 * Compile-time proof of the ceiling. If someone appends a fourth gesture, this line
 * fails to typecheck. That is the intended outcome: adding one is a product decision
 * that needs a DEVIATIONS.md entry, not a one-line array edit.
 */
type ExactlyThree<T extends readonly unknown[]> = T['length'] extends 3 ? T : never;
const SHARING_CEILING: ExactlyThree<typeof SHARING_GESTURES> = SHARING_GESTURES;

export const SHARING_GESTURE_COUNT: 3 = SHARING_CEILING.length;

export function isSharingGesture(value: string): value is SharingGesture {
  return (SHARING_GESTURES as readonly string[]).includes(value);
}
